
export default {
  name: 'LearnMoreBtn',
}
